import * as Yup from "yup";

const pedagioValidator = Yup.object().shape({
  cnpjFornecedora: Yup.string().required("CNPJ da Fornecedora"),
  cnpjPagador: Yup.string().required("CNPJ do Pagador"),
  comprovante: Yup.string().required("Comprovante do Pedágio"),
  valor: Yup.number().required("Valor do Pedágio"),
});

export default pedagioValidator;
